import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

const AboutUs = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
      backgroundColor: "white",
      color: "black",
      fontFamily: "Arial, sans-serif"
    }}>
      <Navbar />
      <main style={{
        flex: "1",
        padding: "20px",
        width: "100%",
        boxSizing: "border-box",
        marginTop: "40px",
      }}>
        <div style={{ maxWidth: '900px', alignContent: 'center', margin: '0 auto', padding: '20px' }}>
          {/* Heading Section */}
          <div style={{ textAlign: 'left' }}>
            <h3>About Us</h3>
            <p style={{ textAlign: 'justify', fontSize: "18px", }}>
              We are a team of <strong>Lawyers and Tech Experts</strong> on a mission to empower fellow lawyers and litigants (those involved in legal cases) with cutting-edge, <strong>AI-powered legal intelligence and strategies</strong>. Our goal is to help secure litigants’ rights, strengthen legal advocacy, and ensure faster case resolution.
            </p>
          </div>
          <br></br>
          {/* How We Help You Section */}
          <div style={{ textAlign: 'left' }}>
            <h3>How We Help You</h3>
            <p style={{ textAlign: 'justify', fontSize: "18px", }}>
              Our custom-trained AI analyzes your case documents against the laws and judgments and provides actionable insights and effective legal strategies for faster and fair case outcome. Whether you’re a lawyer seeking to enhance your practice or a litigant navigating your legal cases, our platform is designed to support you every step of the way.
            </p>
          </div>
          <br></br>
          {/* What Our Platform Offers Section */}
          <div style={{ textAlign: 'left' }}>
            <h3>What Our Platform Offers</h3>
            <p style={{ textAlign: 'justify', fontSize: "18px", }}>Our current version supports legal research for <strong>Matrimonial FIRs under Indian laws</strong>, providing:</p>
            <ul style={{ listStyleType: 'disc', textAlign: 'left', padding: '0 20px' }}>
              <li style={{ marginBottom: '10px', fontSize: "18px", }}>
                <strong>Detailed Analysis of Allegations:</strong><br />
                Understand the core issues in the FIR with a clear breakdown of the allegations.
              </li>
              <li style={{ marginBottom: '10px', fontSize: "18px", }}>
                <strong>Rights of Complainant & Accused:</strong><br />
                Know the applicable rights and remedies, ensuring informed decision-making.
              </li>
              <li style={{ marginBottom: '10px', fontSize: "18px", }}>
                <strong>Fair Investigation Points:</strong><br />
                Identify crucial points in the FIR to seek a fair and proper police investigation.
              </li>
              <li style={{ marginBottom: '10px', fontSize: "18px", }}>
                <strong>Evidence Mapping:</strong><br />
                Identify crucial evidence (documents, witnesses, facts) for proving or defending the FIR.
              </li>
              <li style={{ marginBottom: '10px', fontSize: "18px", }}>
                <strong>Effective Legal Strategies:</strong><br />
                Access actionable strategies to expedite case conclusion and achieve timely justice.
              </li>
              <li style={{ marginBottom: '10px', fontSize: "18px", }}>
                <strong>AI-Generated Applications:</strong><br />
                Generate clear, precise, and well-reasoned applications to seek proper investigation of the FIR.
              </li>
            </ul>
            <br></br>
          </div>
          <div style={{ textAlign: 'left' }}>
            <h3>Want to see how we analyze an FIR and generate applications?</h3>
            <p style={{ textAlign: 'justify', fontSize: "18px", }}>Sign up now to check a sample FIR analysis and AI-assisted legal drafting.</p>
            <br></br>
          </div>
          <div style={{ textAlign: 'left' }}>
            <h3>Start Your Free Beta Trial Today</h3>
            <p style={{ textAlign: 'justify', fontSize: "18px", }}>
              {/* Sign up now and get <strong>two free vouchers</strong> for FIR analysis to explore AI-powered legal research. */}
              Sign up now and receive <strong>two complimentary vouchers</strong> for AI-powered FIR analysis! Experience faster, smarter legal research at no cost.
            </p>
            <p style={{ textAlign: 'justify', fontSize: "18px", }}>
              If you require additional vouchers, please reach out to us at <strong>contact@legalapp.in</strong>.
            </p>
            {/* <p style={{ textAlign: 'justify', fontSize: "18px", }}>
              Hurry—this offer is for a limited time only!
            </p> */}
            {/* <p style={{ textAlign: 'justify', fontSize: "20px", }}>
              We offer flexible subscription plans designed to suit law firms and individual litigants.
            </p> */}
          </div>
          <br></br>
        </div>

        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            onClick={() => localStorage.getItem('firstName') !== null ? navigate("/upload") : navigate("/login")}
            style={{
              fontSize: "18px",
              //   color: "#1565C0", // Blue color
              // color: "#007bff",
              color: '#094268',
              background: "transparent",
              border: "none",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontWeight: "bold",
              marginBottom: "130px"
            }}
          >
            Continue <span style={{ fontSize: "20px" }}>→</span>
          </button>
        </div>
      </main>
      <Footer />
    </div >
  );
};

export default AboutUs;
